export default [
  {
    dataIndex:'nutritionName',
    scopedSlots: { customRender: 'nutritionName' },
    // title:'指标名称',
    slots: { title: 'customTitle' },
    fixed: 'left',
    ellipsis: true,
    width: 160,
  },
  {
    dataIndex:'unit',
    title:'单位',
    ellipsis: true,
    width: 60,
  },
  {
    dataIndex:'content',
    scopedSlots: { customRender: 'content' },
    title:'数值',
    sorter: (a, b) => a.content - b.content,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    align:'center',
    width: 100,
  },
  {
    dataIndex:'productContent',
    align:'center',
    title: '产品',
    scopedSlots: {customRender: 'productContent'},
    sorter: (a, b) => a.productContent - b.productContent,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:100
  },
  {
    dataIndex:'minValue',
    scopedSlots: {customRender: 'minValue'},
    title: '最小值',
    sorter: (a, b) => a.minValue - b.minValue,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    align:'center',
    width:100,
  },
  {
    dataIndex:'maxValue',
    scopedSlots: {customRender: 'maxValue'},
    align:'center',
    title: '最大值',
    sorter: (a, b) => a.maxValue - b.maxValue,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:100,
  },
  {
    dataIndex:'cost',
    title:'单位成本',
    sorter: (a, b) => a.cost - b.cost,
    align:'center',
    scopedSlots: {customRender: 'cost'},
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width: 100,
  },
  {
    dataIndex:'minApply',
    title:'适用下限',
    align:'center',
    sorter: (a, b) => a.minApply - b.minApply,
    scopedSlots: {customRender: 'minApply'},
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width: 100,
  },
  {
    dataIndex:'maxApply',
    title:'适用上限',
    align:'center',
    sorter: (a, b) => a.maxApply - b.maxApply,
    scopedSlots: {customRender: 'maxApply'},
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:  100,
  },
  {
    dataIndex:'minLimitValue',
    scopedSlots: {customRender: 'minLimitValue'},
    align:'center',
    title: '极下限',
    sorter: (a, b) => a.minLimitValue - b.minLimitValue,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:  100,
  },
  {
    dataIndex:'maxLimitValue',
    scopedSlots: {customRender: 'maxLimitValue'},
    align:'center',
    title:'极上限',
    sorter: (a, b) => a.maxLimitValue - b.maxLimitValue,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width:  100,
  },
  ]